import React, { useState } from 'react';
import styles from './Contact.module.scss';

export const ContactContainer = () => {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        message: '',
        email_address: '',
        phone_number: '',
    });
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true); // Show spinner
        setErrorMessage(''); // Reset error message
        setSuccessMessage(''); // Reset success message

        try {
            const response = await fetch(
                'https://us-central1-stameywhitelaw.cloudfunctions.net/ServeIntakeRequestForm-6fb5f91',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData),
                }
            );

            setLoading(false); // Stop spinner

            if (response.ok) {
                setSuccessMessage('Thank you! Your message has been sent successfully.');
                setFormData({
                    first_name: '',
                    last_name: '',
                    message: '',
                    email_address: '',
                    phone_number: '',
                }); // Reset the form fields
            } else {
                const errorText = (await response.text()) || `Submission failed with status ${response.status}`;
                setErrorMessage(errorText);
            }
        } catch (error) {
            setLoading(false);
            setErrorMessage('An error occurred during submission. Please try again later.');
            console.error('Submission Error:', error);
        }
    };

    return (
        <div className={styles['contact-container']}>
            <div className={styles['black-bg']}>
                <div className={styles['bottom-row']}>
                    <div className={styles['card5']}>
                        <div className={styles['title']}>
                            <p>Get In Touch</p>
                            <p>Contact</p>
                        </div>
                        <div className={styles['form']}>
                            {successMessage && (
                                <div className={styles['success-message']}>
                                    <p>{successMessage}</p>
                                </div>
                            )}
                            {errorMessage && (
                                <div className={styles['error-message']} style={{ color: 'red' }}>
                                    <p>{errorMessage}</p>
                                </div>
                            )}
                            <form onSubmit={handleSubmit}>
                                <div className={styles['row']}>
                                    <div className={styles['field']}>
                                        <div className={styles['label']}>
                                            <label htmlFor="first_name">First Name:</label>
                                        </div>
                                        <div className={styles['input']}>
                                            <input
                                                type="text"
                                                id="first_name"
                                                name="first_name"
                                                value={formData.first_name}
                                                onChange={handleChange}
                                                title="First name should contain a-z characters"
                                                required
                                                pattern="(^[a-zA-Z]{1,30}$)"
                                            />
                                        </div>
                                    </div>
                                    <div className={styles['field']}>
                                        <div className={styles['label']}>
                                            <label htmlFor="last_name">Last Name:</label>
                                        </div>
                                        <div className={styles['input']}>
                                            <input
                                                type="text"
                                                id="last_name"
                                                name="last_name"
                                                value={formData.last_name}
                                                onChange={handleChange}
                                                title="Last name should contain a-z characters"
                                                required
                                                pattern="(^[a-zA-Z]{1,30}$)"
                                            />
                                        </div>
                                    </div>
                                    <div className={styles['field']}>
                                        <div className={styles['label']}>
                                            <label htmlFor="message">Message:</label>
                                        </div>
                                        <div className={styles['input']}>
                      <textarea
                          id="message"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                      ></textarea>
                                        </div>
                                    </div>
                                    <div className={styles['field']}>
                                        <div className={styles['label']}>
                                            <label htmlFor="email_address">Email:</label>
                                        </div>
                                        <div className={styles['input']}>
                                            <input
                                                type="email"
                                                id="email_address"
                                                name="email_address"
                                                value={formData.email_address}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className={styles['field']}>
                                        <div className={styles['label']}>
                                            <label htmlFor="phone_number">Phone:</label>
                                        </div>
                                        <div className={styles['input']}>
                                            <input
                                                type="tel"
                                                id="phone_number"
                                                name="phone_number"
                                                value={formData.phone_number}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={styles['button-wrapper']}>
                                    <button type="submit" disabled={loading}>
                                        {loading ? 'Sending...' : 'Send My Message'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};